import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdobeLaunchService } from '../shared/services/adobe-launch.service';
import { PAGE_TITLES, PATH_TRANSLATIONS, resolveSupportedLang } from '../shared/config/localized-paths';
import { environment } from '../../environments/environment';
import {
  buildHowItWorksContent,
  buildProgramBenefitsContent,
  DIGITAL_INTRO_BANNER_ASSETS,
  ProductHowItWorksContent,
  ProductProgramBenefitsContent,
} from './digital.content';

@Component({
  selector: 'app-digital',
  templateUrl: './digital.component.html',
  styleUrls: ['./digital.component.scss'],
})
export class DigitalComponent implements OnInit {
  public readonly introBannerAssets = DIGITAL_INTRO_BANNER_ASSETS;
  public digitalSignUpUrl!: string;
  public productHowItWorksContent!: ProductHowItWorksContent;
  public productProgramBenefitsContent!: ProductProgramBenefitsContent;

  constructor(
    private readonly _adobeLaunchService: AdobeLaunchService,
    private readonly _translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    const lang = this._translateService.currentLang;
    const resolvedLang = resolveSupportedLang(lang);

    this.digitalSignUpUrl = `${environment.digitalUiBaseUrl}/${resolvedLang}/${PATH_TRANSLATIONS[resolvedLang]['register']}`;

    this.productHowItWorksContent = buildHowItWorksContent((key) =>
      this._translateService.instant(key),
    );

    this.productProgramBenefitsContent = buildProgramBenefitsContent(
      (key) => this._translateService.instant(key),
      resolvedLang,
    );

    this._adobeLaunchService.trackPageView({
      pageTitle: PAGE_TITLES[resolvedLang].digital,
    });
  }
}
